import * as React from 'react'
import { FC } from 'react'
import MenuItem from '@mui/material/MenuItem'
import { Field } from 'formik'
import { BaseTextField } from '@user/components/Formik'
import { selectAllCancelReasons } from '@user/store/scheduling/cancelReasonsSlice'
import { useSelector } from 'react-redux'

export const CancelAppointmentReasonSelect: FC = () => {
  const cancelReasons = useSelector(selectAllCancelReasons)

  return (
    <Field
      name="notServicedReason"
      component={BaseTextField}
      label="Cancel Appointment Reason"
      select
    >
      {cancelReasons.map((b) => (
        <MenuItem key={b.id} value={b.name}>
          {b.name} - {b.description}
        </MenuItem>
      ))}
    </Field>
  )
}
CancelAppointmentReasonSelect.displayName = 'CancelAppointmentReasonSelect'
